<template>
  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">

    <div class="popup-cont">
      <h2 class="popup-heading">{{dataProp ? 'Save' : 'ADD NEW'}}</h2>
      <div class="popup-item justify-center">
        <div class="upload-image height-fix"><img :src="dataImg"/></div>
        <div>
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" name="content-image" accept="image/*" />
          <div class="text-danger text-sm text-center" v-show="errors.has('content-image')">{{ errors.first('content-image') }}</div>
          <div class="tr-button blue-button list-button" @click="$refs.uploadImgInput.click()">Upload Image</div>
          <div class="tr-button list-button" @click="(() => {
            dataImg = require('@/assets/images/pages/register/upload_image.png')
          })" >Remove Image</div>
        </div>
      </div>
      <div class="popup-item">
        <h4>Deal Name</h4>
        <input type="text" class="pop-input" v-model="shortContent" placeholder="Deal Name" name="Deal Name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Deal Name')">{{ errors.first('Deal Name') }}</span>
      </div>
      <div class="popup-item">
        <h4>Deal Description</h4>
        <vue-editor v-model="longContent" v-validate="'required'"></vue-editor>
<!--        <textarea class="pop-textarea" placeholder="Description" name="Description"  v-validate="'required'" v-model="longContent"></textarea>-->
        <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>

      </div>

      <div class="popup-item" v-if="restaurantlist">
        <h4>Restaurant</h4>
        <v-select v-model="restaurant_id" class="w-full rounded-lg cursor-pointer" placeholder="Please select"
                  :clearable="false" name="restaurant" v-validate="'required'" :options="restaurant_select"/>
        <span class="text-danger text-sm" v-show="errors.has('restaurant')">{{ errors.first('restaurant') }}</span>
      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" @click="submitData">{{dataProp ? 'Save' : 'Add New'}} Deal</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import { VueEditor } from 'vue2-editor'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object
    },
    end: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    VueEditor
  },
  data () {
    return {
      dataImg: require('@/assets/images/pages/register/upload_image.png'),
      uploadImg: null,
      name: '',
      shortContent: '',
      longContent: '',
      restaurant_id: null,
      contentId: null,
      selectRestaurant: null
    }
  },
  mounted () {
    if (!this.restaurantlist) {
      this.getUserList()
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        this.initValues()
        return
      } else if (this.dataProp) {
        const { name, id, restaurant_id, contentType, shortContent, longContent, contentImageUrl } = JSON.parse(JSON.stringify(this.dataProp))
        this.contentId = id
        this.name = name
        this.contentType = contentType
        this.shortContent = shortContent
        this.restaurant_id = restaurant_id === 0 ? null : this.restaurant_select.filter(rest => rest.value === restaurant_id)[0]
        this.longContent = longContent
        this.dataImg = (contentImageUrl !== null) ? contentImageUrl : require('@/assets/images/pages/register/upload_image.png')
        this.imgCss = ''

      }
      return true
    },
    restaurant_id (newRestaurant) {
      this.selectRestaurant = newRestaurant.label
    }
  },
  computed: {
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    restaurant_select () {
      return this.restaurantlist.map(restaurant => {
        return  {
          label: restaurant.user_property['Restaurant-Name'],
          value: restaurant.id
        }
      })
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist || JSON.parse(localStorage.getItem('restaurantlist'))
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {

    handleFocus () {
      // do something here
    },
    handleFocusOut () {
      // do something here
    },
    initValues () {
      this.contentId = null
      this.name = ''
      this.shortContent = ''
      this.longContent = ''
      this.restaurant_id = null
      this.dataImg = require('@/assets/images/pages/register/upload_image.png')
      this.imgCss = 'm-w-150'
    },

    getUserList () {
      const payload = {
        user_group: 2
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUserList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
          this.imgCss = ''
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]
      }
    },

    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const obj = {
            contentType: 'campaign',
            name: this.selectRestaurant,
            shortContent: this.shortContent,
            longContent: this.longContent,
            restaurant_id: this.restaurant_id ? this.restaurant_id.value : 0,
            contentId: this.contentId
          }

          if (this.uploadImg) {
            obj['contentImage'] = this.uploadImg
          }

          this.$store.dispatch('api/uploadContent', obj,  event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          }).then((response) => {
            this.$vs.notify({
              title: 'Content Saved',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
            this.isSidebarActiveLocal = false
          }).catch(err => {
            console.error(err)
            if (err.message.contains('Content saved')) {
              this.$vs.notify({
                title: 'Content Saved',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            } else {
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
            this.$vs.loading.close()
          })

        }
      })
    }
  }
}
</script>

<style lang="scss">
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .popup-cont {
    height: auto !important;
    overflow: auto;


    .popup-item {
      .upload-image {

        max-height: 30vh;
        overflow: auto;
      }
    }
  }

  .ql-editor {
    max-height: 150px;
    min-height: unset;
  }
</style>
